'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var baseBus = require('./base-bus.js');
var payloadMismatchError = require('./payload-mismatch-error.js');

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const logCss = "background-color: brown; color: white";
class CommandBus extends baseBus.BaseBus {
  subscribe(channel, callback) {
    if (typeof callback !== "function") {
      throw new Error("Callback function must be supplied as the second argument.");
    }
    if (!!this.getHandler(channel)) {
      throw new Error(`Handler for this command already registered (channel = ${channel}).`);
    }
    this.logRegisteredHandler(channel);
    this.setHandler(channel, callback);
    return this.getSubscription(channel);
  }
  publish(channel, payload) {
    if (!this.getHandler(channel)) {
      this.logMissingHandler(channel);
      return;
    }
    const schema = this.getSchema(channel);
    if (this.isPayloadInvalid(channel, payload)) {
      throw new payloadMismatchError.PayloadMismatchError(channel, schema, payload);
    }
    this.logPublishedMessage(channel, payload);
    this.setLatest(channel, payload);
    return this.resolveHandler(channel, payload);
  }
  getHandler(channel) {
    var _a;
    return (_a = this._subscriptions.get(channel)) == null ? void 0 : _a.handler;
  }
  setHandler(channel, callback) {
    if (!this._subscriptions.has(channel)) {
      this.initChannel(channel);
    }
    this._subscriptions.get(channel).handler = callback;
  }
  resolveHandler(channel, payload) {
    return new Promise((resolve, reject) => __async(this, null, function* () {
      try {
        yield this.getHandler(channel)({
          channel,
          payload
        });
        resolve();
      } catch (e) {
        reject(e);
      }
    }));
  }
  getSubscription(channel) {
    return {
      unsubscribe: () => delete this._subscriptions.get(channel).handler
    };
  }
  logRegisteredHandler(channel) {
    this.log("%cCommand bus: registered handler for channel", logCss, channel);
  }
  logMissingHandler(channel) {
    this.log("%cCommand bus: handler is missing for channel", logCss, channel);
  }
  logPublishedMessage(channel, payload) {
    this.log("%cCommand bus: resolving publish for channel", logCss, channel);
    this.log(`%cCommand bus: message payload`, logCss, payload);
  }
}

exports.CommandBus = CommandBus;
